class GridLayoutDirective {
    constructor($scope, $routeParams, $config, TaskDataService, $signals, $timeout,
                $translate, CMSSortableService, $uibModal, DeleteObjectHelperService,
                SheetLoadedService, CopyContainerHelperService, CryptoHelperService,
                TaskSelectionService) {
        this.$scope = $scope;
        this.$routeParams = $routeParams;
        this.$config = $config;
        this.TaskDataService = TaskDataService;
        this.$signals = $signals;
        this.$timeout = $timeout;
        this.$translate = $translate;
        this.CMSSortableService = CMSSortableService;
        this.$uibModal = $uibModal;
        this.DeleteObjectHelperService = DeleteObjectHelperService;
        this.SheetLoadedService = SheetLoadedService;
        this.CopyContainerHelperService = CopyContainerHelperService;
        this.CryptoHelperService = CryptoHelperService;
        this.TaskSelectionService = TaskSelectionService;

        this.inheritScopeVars($scope);
        this.initialize($scope);
    }

    inheritScopeVars($scope) {
        if (angular.isDefined($scope.$parent) && angular.isDefined($scope.$parent.responseFolderURL)) {
            $scope.responseFolderURL = $scope.$parent.responseFolderURL;
        }
    }

    initialize($scope) {
        const taskContext = this.TaskDataService.fetchContext();

        $scope.rows = $scope.layout ? $scope.layout.getRows() : null;
        $scope.debugPanelCollapsed = true;

        $scope.rowHeadlines = {};
        $scope.colHeadlines = {};
        $scope.colHeadlinesMessage = {};
        $scope.inusedColHeadlines = {};

        $scope.activeTab = {};
        $scope.activeCarousel = {};
        $scope.activeIaaContent = {};

        if ($scope.sheet && $scope.sheet.isJournal()) {
            this.initializeJournalFunctionality($scope);
        }

        $scope.isCMS = isCMS;
        $scope.isPDFMode = this.$config.isPDFMode();

        if ($scope.isCMS && !this.$config.isPreviewMode()) {
            this.initializeCMSMode($scope, taskContext);
        } else {
            this.generateHeadlines($scope, this.$timeout, this.$translate, taskContext, this.SheetLoadedService);
        }

        $scope.pdfFilter = this.createPDFFilter($scope, taskContext);
    }

    initializeJournalFunctionality($scope) {
        this.$signals.remove('openJournalSaveModal');
        this.$signals.on('openJournalSaveModal', () => {
            let modalInstance = this.$uibModal.open({
                templateUrl: 'views/ib/modules/sheet/journalSaveModal.html',
                controller: function ($scope, $uibModalInstance, TaskCountdownService) {
                    $scope.onContinue = function () {
                        let _taskCountdown = TaskCountdownService.getInstance();
                        $scope.$close();
                        _taskCountdown.setTotalAvailableMillis(-1);
                    }
                }
            });
        });

        $scope.onContinueJournal = () => {
            this.$signals.emit('openJournalSaveModal');
        };
    }

    initializeCMSMode($scope, taskContext) {
        this.generateHeadlines($scope, this.$timeout, this.$translate, taskContext, this.SheetLoadedService);

        $scope.$signals = this.$signals;

        this.CMSSortableService.setLayout($scope.layout);
        $scope.sortableOption = this.CMSSortableService.getSortableOption();
        $scope.connectWith = this.CMSSortableService.getConnectWith();
        $scope.onMouseDown = this.CMSSortableService.getOnMouseDown();
        $scope.onMouseUp = this.CMSSortableService.getOnMouseUp();

        $scope.questionParts = this.getQuestionPartList($scope.sheet, taskContext, this.$routeParams, this.$translate);

        $scope.onChangeSticky = () => {
            $scope.layout.flagAsDirty();
        };

        this.signals($scope, this.$signals, this.$translate, taskContext, this.$timeout, this.CMSSortableService, this.$uibModal, this.$routeParams, $scope.sheet, this.DeleteObjectHelperService, this.SheetLoadedService, this.CopyContainerHelperService, this.CryptoHelperService, this.TaskSelectionService);
    }

    createPDFFilter($scope, taskContext) {
        return (contentUUID) => {
            if (!$scope.filterBy || !$scope.isPDFMode) {
                return true;
            }
            const contentObj = taskContext.read(contentUUID);
            let doNotShow = false;
            if (contentObj.getQuestionPart() !== null && $scope.filterBy === contentObj.getQuestionPart().getUUID()) {
                doNotShow = true;
            }
            return doNotShow;
        };
    }

    openDeleteModal(message) {
        return this.$uibModal.open({
            templateUrl: "/views/ib/components/modal/deleteElementModal.html",
            windowClass: "delete-element-modal",
            keyboard: false,
            backdrop: 'static',
            controller: function ($scope, $uibModalInstance, message) {
                $scope.infoMessageModal = message;

                $scope.onCancelBtnClick = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                $scope.onDeleteBtnClick = function () {
                    $uibModalInstance.delete = true;
                    $uibModalInstance.dismiss('cancel');
                };
            },
            resolve: {
                message: function () {
                    return message;
                }
            }
        });
    }

    getHeadlineObjByColKey(colPosition, col, colKey, rowKey, colLength, position, positionInRow, taskContext, $scope) {
        let headlines = {};
        let list = col.list[colKey];
        let questionPart = null;
        //console.log("getHeadlineObjByColKey", list);
        if (typeof list.questionPartUUID === 'undefined') {
            let contentObj = undefined;
            let container_uuid = list.content;
            //console.log("container_uuid", container_uuid);
            if (angular.isUUID(container_uuid)) {
                contentObj = taskContext.read(list.content);
            }
            //console.log("contentObj", contentObj);
            if (contentObj && contentObj.data.questionPart) {
                questionPart = contentObj.getQuestionPart();
            }
        } else if (list.questionPartUUID !== null) {
            questionPart = taskContext.readQuestionPart(list.questionPartUUID);
        }

        if (questionPart !== null) {
            if ($scope.sheet.isUseQuestionParts() && questionPart.data.isDefaultQuestionPart) {
                delete contentObj.data.questionPart;
                return null;
            }

            headlines[position] = {
                contentUUID: list.content,
                questionPart: questionPart,
                position: position,
                positionInRow: positionInRow,
                colLength: colLength,
                rowKey: rowKey
            };
            if (colLength === 2) {
                headlines[position].colPosition = colPosition;
                headlines[position].listLength = Object.keys(col.list).length;
                headlines[position].listLengthWithQuestionPart = 0;
                angular.forEach(col.list, function (list, listKey) {
                    let tmp_contentObj = taskContext.read(list.content);
                    if (tmp_contentObj.getQuestionPart()) {
                        headlines[position].listLengthWithQuestionPart++;
                    }
                });
            }

            position++;
            positionInRow++;

            return {
                headlines: headlines,
                position: position,
                positionInRow: positionInRow
            };
        }
        return null;
    }

    getHeadlines($scope, taskContext) {
        let headlines = {};
        let position = 0;
        let columnLength = 0;

        console.log("rows", $scope.rows, $scope);
        for (let i = 0; i < $scope.rows.length; i++) {
            for (let j = 0; j < $scope.rows[i].cols.length; j++) {
                columnLength += $scope.rows[i].cols[j].list.length;
            }
        }

        angular.forEach($scope.rows, (row, rowKey) => {
            delete $scope.rowHeadlines[rowKey];
            let colLength = Object.keys(row.cols).length;

            let col1 = row.cols[0];
            let col2 = row.cols[1];

            let counter = 0;

            let stop = false;
            let col1Stop = false;
            let col2Stop = false;

            let positionInRow = 0;

            while (!stop) {
                if (col1) {
                    let key1 = Object.keys(col1.list)[counter];
                    if (col1.list[key1]) {
                        let headlinesArray = this.getHeadlineObjByColKey(1, col1, key1, rowKey, colLength, position, positionInRow, taskContext, $scope);
                        if (headlinesArray !== null) {
                            angular.extend(headlines, headlinesArray.headlines);
                            position = headlinesArray.position;
                            positionInRow = headlinesArray.positionInRow;
                        }
                    } else if (!col1Stop) {
                        col1Stop = true;
                    }
                } else {
                    col1Stop = true;
                }

                if (col2) {
                    let key2 = Object.keys(col2.list)[counter];
                    if (col2.list[key2]) {
                        let headlinesArray = this.getHeadlineObjByColKey(2, col2, key2, rowKey, colLength, position, positionInRow, taskContext, $scope);
                        if (headlinesArray !== null) {
                            angular.extend(headlines, headlinesArray.headlines);
                            position = headlinesArray.position;
                            positionInRow = headlinesArray.positionInRow;
                        }
                    } else if (!col2Stop) {
                        col2Stop = true;
                    }
                } else {
                    col2Stop = true;
                }

                if (counter > columnLength || (col1Stop && col2Stop)) {
                    stop = true;
                }
                counter++;
            }
        });

        return headlines;
    }

    validateHeadlines($scope, $translate, headlines) {
        const existsInRowHeadline = uuid => 
            Object.values($scope.rowHeadlines).some(value => value.data.uuid === uuid);
    
        const existsInColHeadline = uuid =>
            Object.values($scope.colHeadlines).some(value => value.data.uuid === uuid);
    
        const colMessage = (level, contentUUID, message, statuscode) => {
            $scope.colHeadlinesMessage ??= {};
            $scope.colHeadlinesMessage[contentUUID] ??= [];
    
            $scope.colHeadlinesMessage[contentUUID].push({
                type: level,
                message,
                statuscode
            });
        };
    
        const handleSameColumnPosition = (value, prevHeadline, colMessage, $translate, $scope) => {
            if (prevHeadline.equalHeadlineCounter > 2) {
                colMessage('info', value.contentUUID,
                    $translate.instant('CMS.LAYOUT-MANAGER.INFO-MESSAGES.01', {
                        s1: value.questionPart.getShortTitle()
                    }), 1);
    
                colMessage('info', prevHeadline.contentUUID,
                    $translate.instant('CMS.LAYOUT-MANAGER.INFO-MESSAGES.02', {
                        s1: value.questionPart.getShortTitle()
                    }), 2);
    
                value.removeRowHeadline = true;
                return true;
            } 
            
            if (prevHeadline.equalHeadlineCounter === 1) {
                colMessage('info', value.contentUUID,
                    $translate.instant('CMS.LAYOUT-MANAGER.INFO-MESSAGES.03', {
                        s1: value.questionPart.getShortTitle()
                    }), 3);
    
                colMessage('info', prevHeadline.contentUUID,
                    $translate.instant('CMS.LAYOUT-MANAGER.INFO-MESSAGES.04', {
                        s1: value.questionPart.getShortTitle()
                    }), 4);
    
                value.removeRowHeadline = true;
    
                if (!existsInRowHeadline(value.questionPart.data.uuid)) {
                    $scope.rowHeadlines[prevHeadline.rowKey] = value.questionPart;
                }
                delete $scope.colHeadlines[prevHeadline.contentUUID];
                return true;
            }
    
            return false;
        };
    
        const handleDifferentColumnPosition = (value, prevHeadline, prevPrevHeadline, colMessage, $translate, $scope) => {
            if (prevHeadline.equalHeadlineCounter > 2) {
                colMessage('info', value.contentUUID,
                    $translate.instant('CMS.LAYOUT-MANAGER.INFO-MESSAGES.05', {
                        s1: value.questionPart.getShortTitle()
                    }), 5);
    
                colMessage('info', prevHeadline.contentUUID,
                    $translate.instant('CMS.LAYOUT-MANAGER.INFO-MESSAGES.06', {
                        s1: value.questionPart.getShortTitle()
                    }), 6);
    
                value.removeRowHeadline = true;
                return true;
            } 
            
            if (prevHeadline.equalHeadlineCounter === 1) {
                if (prevPrevHeadline &&
                    prevHeadline.rowKey === prevPrevHeadline.rowKey &&
                    (prevPrevHeadline.equalHeadlineCounter > 1 || 
                     prevPrevHeadline.questionPart.data.uuid !== value.questionPart.data.uuid)) {
                    
                    colMessage('warning', value.contentUUID,
                        $translate.instant('CMS.LAYOUT-MANAGER.WARNING-MESSAGES.03', {
                            s1: value.questionPart.getShortTitle()
                        }), 3);
                    colMessage('warning', prevHeadline.contentUUID,
                        $translate.instant('CMS.LAYOUT-MANAGER.WARNING-MESSAGES.04', {
                            s1: value.questionPart.getShortTitle()
                        }), 4);
    
                    return 'error';
                } 
                
                colMessage('info', value.contentUUID,
                    $translate.instant('CMS.LAYOUT-MANAGER.INFO-MESSAGES.03', {
                        s1: value.questionPart.getShortTitle()
                    }), 3);
    
                colMessage('info', prevHeadline.contentUUID,
                    $translate.instant('CMS.LAYOUT-MANAGER.INFO-MESSAGES.04', {
                        s1: value.questionPart.getShortTitle()
                    }), 4);
    
                value.removeRowHeadline = true;
    
                if (!existsInRowHeadline(value.questionPart.data.uuid)) {
                    $scope.rowHeadlines[prevHeadline.rowKey] = value.questionPart;
                }
                delete $scope.colHeadlines[prevHeadline.contentUUID];
            }
    
            return false;
        };
    
        const usedHeadlines = new Map();
        let equalHeadlineCounter = 1;
        let rowKey = 0;
    
        Object.entries(headlines).forEach(([key, value]) => {
            const prevHeadline = headlines[parseInt(key) - 1];
            const nextHeadline = headlines[parseInt(key) + 1];
            const prevPrevHeadline = headlines[parseInt(key) - 2];
    
            if (rowKey !== value.rowKey) {
                rowKey = value.rowKey;
                equalHeadlineCounter = 1;
            }
    
            if (!prevHeadline) {
                const isFirstOrLastInRow = value.rowKey === 0 || 
                    !nextHeadline || 
                    (nextHeadline?.rowKey !== value.rowKey);
    
                if (isFirstOrLastInRow && value.listLengthWithQuestionPart === 1) {
                    $scope.rowHeadlines[value.rowKey] = value.questionPart;
                } else {
                    $scope.colHeadlines[value.contentUUID] = value.questionPart;
                }
                return;
            }
    
            if (prevHeadline.questionPart.data.uuid === value.questionPart.data.uuid && value.colLength) {
                if (prevHeadline.removeRowHeadline) {
                    value.removeRowHeadline = true;
                    return;
                }
    
                let error = false;
                equalHeadlineCounter++;
                value.equalHeadlineCounter = equalHeadlineCounter;
    
                if (equalHeadlineCounter === 2 && 
                    (equalHeadlineCounter % 2) === ((value.positionInRow + 1) % 2) && 
                    (value.positionInRow + 1) > 3) {
    
                    colMessage('warning', value.contentUUID,
                        $translate.instant('CMS.LAYOUT-MANAGER.WARNING-MESSAGES.01', {
                            s1: value.questionPart.getShortTitle()
                        }), 1);
    
                    colMessage('warning', prevHeadline.contentUUID,
                        $translate.instant('CMS.LAYOUT-MANAGER.WARNING-MESSAGES.02', {
                            s1: value.questionPart.getShortTitle()
                        }), 2);
    
                    error = true;
                }
    
                if (prevHeadline.rowKey !== value.rowKey && 
                    prevHeadline.position === (value.position - 1)) {
                    
                    if (equalHeadlineCounter % 2 === 0) {
                        if (prevHeadline.colPosition === value.colPosition) {
                            if (handleSameColumnPosition(value, prevHeadline, colMessage, $translate, $scope)) {
                                return;
                            }
                        } else if (prevHeadline.colPosition !== value.colPosition && 
                                  prevHeadline.colLength === 2) {
                            const result = handleDifferentColumnPosition(value, prevHeadline, prevPrevHeadline, 
                                                                       colMessage, $translate, $scope);
                            if (result === true) return;
                            if (result === 'error') error = true;
                        }
                    }
    
                    if (nextHeadline?.colPosition === 2 &&
                        nextHeadline.questionPart.data.uuid !== value.questionPart.data.uuid &&
                        nextHeadline.rowKey === value.rowKey) {
    
                        colMessage('warning', nextHeadline.contentUUID,
                            $translate.instant('CMS.LAYOUT-MANAGER.WARNING-MESSAGES.05', {
                                s1: nextHeadline.questionPart.getShortTitle(),
                                s2: value.questionPart.getShortTitle()
                            }), 5);
    
                        error = true;
                    }
                }
    
                if ($scope.colHeadlinesMessage[prevHeadline.contentUUID]) {
                    $scope.colHeadlinesMessage[prevHeadline.contentUUID]
                        .filter(v => v.statuscode === 9)
                        .forEach(v => colMessage(v.type, value.contentUUID, v.message, v.statuscode));
                }
    
                if (error) {
                    $scope.colHeadlines[value.contentUUID] = value.questionPart;
                } else {
                    if (prevHeadline.rowKey !== value.rowKey) {
                        value.removeRowHeadline = true;
                    } else {
                        if (!existsInRowHeadline(value.questionPart.data.uuid)) {
                            $scope.rowHeadlines[value.rowKey] = value.questionPart;
                        }
                        delete $scope.colHeadlines[prevHeadline.contentUUID];
                    }
                }
            } else if (!usedHeadlines.has(value.questionPart.data.uuid)) {
                equalHeadlineCounter = 1;
                value.equalHeadlineCounter = equalHeadlineCounter;
                $scope.colHeadlines[value.contentUUID] = value.questionPart;
    
                if (this.checkSpecialConditions(value, prevHeadline, nextHeadline, headlines, 
                                              key, colMessage, $translate, $scope)) {
                    return;
                }
            } else {
                colMessage('warning', value.contentUUID,
                    $translate.instant('CMS.LAYOUT-MANAGER.WARNING-MESSAGES.09', {
                        s1: prevHeadline.questionPart.getShortTitle()
                    }), 9);
    
                $scope.colHeadlines[value.contentUUID] = value.questionPart;
            }
    
            usedHeadlines.set(value.questionPart.data.uuid, { value, key });
        });
    
        $scope.headlines = headlines;
        $scope.usedHeadlines = Object.fromEntries(usedHeadlines);
    }
    
    checkSpecialConditions(value, prevHeadline, nextHeadline, headlines, key, colMessage, $translate, $scope) {
        if (prevHeadline.equalHeadlineCounter > 1 &&
            prevHeadline.colPosition === 1 &&
            prevHeadline.rowKey === value.rowKey &&
            (!nextHeadline || nextHeadline.questionPart.data.uuid !== value.questionPart.data.uuid)) {
            
            if (headlines[key].colPosition === 2) {
                const hasExistingMessage = $scope.colHeadlinesMessage[value.contentUUID]?.some(v => v.statuscode === 5);
                
                if (!hasExistingMessage) {
                    colMessage('warning', value.contentUUID,
                        $translate.instant('CMS.LAYOUT-MANAGER.WARNING-MESSAGES.06', {
                            s1: value.questionPart.getShortTitle(),
                            s2: value.questionPart.getShortTitle(),
                            s3: prevHeadline.questionPart.getShortTitle()
                        }), 6);
                }
            }
        }
    
        const sameRowCondition = nextHeadline?.rowKey === value.rowKey && 
                                prevHeadline.rowKey === value.rowKey;
    
        if (sameRowCondition && 
            nextHeadline?.questionPart.data.uuid === value.questionPart.data.uuid) {
            
            if (nextHeadline.colPosition === 1 && prevHeadline.colPosition === 1) {
                colMessage('warning', value.contentUUID,
                    $translate.instant('CMS.LAYOUT-MANAGER.WARNING-MESSAGES.07', {
                        s1: value.questionPart.getShortTitle()
                    }), 7);
                value.removeRowHeadline = true;
                return true;
            }
    
            if (nextHeadline.colPosition === 2 && prevHeadline.colPosition === 1) {
                delete $scope.rowHeadlines[prevHeadline.rowKey];
                $scope.colHeadlines[prevHeadline.contentUUID] = prevHeadline.questionPart;
                $scope.colHeadlines[value.contentUUID] = value.questionPart;
                value.removeRowHeadline = true;
                return true;
            }
        }
    
        return false;
    }

    generateHeadlines($scope, $timeout, $translate, taskContext, SheetLoadedService) {
        let headlines = this.getHeadlines($scope, taskContext);
        this.validateHeadlines($scope, $translate, headlines);

        $timeout(() => {
            if (typeof $scope.scrollHeight !== 'undefined') {
                if ($scope.scrollToElement !== -1 && typeof $scope.scrollToElement !== 'undefined') {
                    $scope.scrollHeight = $($scope.scrollToElement).offset().top - 100;
                    $scope.scrollToElement = -1;
                }

                if (SheetLoadedService) {
                    SheetLoadedService.getPromise().then(() => {
                        if ($scope.scrollHeight > 0) {
                            $('html, body').animate({
                                scrollTop: $scope.scrollHeight
                            }, 1000);
                        }
                    });
                } else {
                    if ($scope.scrollHeight > 0) {
                        $('html, body').animate({
                            scrollTop: $scope.scrollHeight
                        }, 1000);
                    }
                }
            }
        });
    }

    renderingRows(rows, $scope, $timeout, $translate, taskContext, $uibModal, SheetLoadedService) {
        if (this.renderingRowsActive == true) {
            return false;
        }
        this.renderingRowsActive = true;

        $scope.scrollHeight = $('html, body').scrollTop();
        if ($scope.scrollHeight === 0) {
            $scope.scrollHeight = $(window).scrollTop();
        }

        if (rows === null) {
            rows = $scope.rows;
        }
        $scope.rows = {};
        $scope.rowHeadlines = {};
        $scope.colHeadlines = {};
        $scope.colHeadlinesMessage = {};

        SheetLoadedService.initPromise();

        $timeout(() => {
            $scope.$apply(() => {
                $scope.rows = rows;
                this.generateHeadlines($scope, $timeout, $translate, taskContext, SheetLoadedService);
                $scope.layout.flagAsDirty();
                this.renderingRowsActive = false;
            });
        }, 1);
    }

    deleteElements($scope, taskContext, $signals, deleteObj, DeleteObjectHelperService) {
        const deleteObjects = (entry) => {
            angular.forEach(entry.getObjects(), (obj, objKey) => {
                let containerEntry = taskContext.read(obj);
                containerEntry.flagAsDeleted();
                containerEntry.flagAsDirty();
            });
        };

        const deleteContainer = (containerUUID) => {
            let containerEntry = taskContext.read(containerUUID);
            containerEntry.flagAsDeleted();
            containerEntry.flagAsDirty();

            if (containerEntry.isShowTabs()) {
                angular.forEach(containerEntry.getTabs(), (tab, tabKey) => {
                    let tabEntry = taskContext.read(tab.content);
                    tabEntry.flagAsDeleted();
                    tabEntry.flagAsDirty();
                    deleteObjects(tabEntry);
                });
            } else if (containerEntry.isShowCarousels()) {
                angular.forEach(containerEntry.getCarousels(), (carousel, carouselKey) => {
                    let carouselEntry = taskContext.read(carousel.content);
                    carouselEntry.flagAsDeleted();
                    carouselEntry.flagAsDirty();
                    deleteObjects(carouselEntry);
                });
            } else if (typeof containerEntry.data.objects !== "undefined") {
                deleteObjects(containerEntry);
            }
        };

        if (typeof deleteObj.rowKey !== 'undefined' &&
            typeof deleteObj.colKey !== 'undefined' &&
            typeof deleteObj.containerKey !== 'undefined') {
            let containerUUID = $scope.rows[deleteObj.rowKey].cols[deleteObj.colKey].list[deleteObj.containerKey].content;
            DeleteObjectHelperService.deleteContainer($scope.rows, deleteObj.rowKey, deleteObj.colKey, deleteObj.containerKey, containerUUID);
        } else if (typeof deleteObj.rowKey !== 'undefined' &&
            typeof deleteObj.colKey !== 'undefined') {
            angular.forEach($scope.rows[deleteObj.rowKey].cols[deleteObj.colKey].list, (list, listKey) => {
                let containerUUID = list.content;
                deleteContainer(containerUUID);
            });
            $scope.rows[deleteObj.rowKey].cols.splice(deleteObj.colKey, 1);
        } else if (typeof deleteObj.rowKey !== 'undefined') {
            angular.forEach($scope.rows[deleteObj.rowKey].cols, (col, colKey) => {
                angular.forEach(col.list, (list, listKey) => {
                    let containerUUID = list.content;
                    deleteContainer(containerUUID);
                });
            });
            $scope.rows.splice(deleteObj.rowKey, 1);
        }
        $signals.emit("rendering_rows", $scope.rows);
        $scope.layout.flagAsDirty();
    }

    signals($scope, $signals, $translate, taskContext, $timeout, CMSSortableService, $uibModal, $routeParams, sheet, DeleteObjectHelperService, SheetLoadedService, CopyContainerHelperService, CryptoHelperService, TaskSelectionService) {
        const helperCounterMethode = (contentObj) => {
            let objectsCounter = 0;
            if (contentObj.isShowTabs()) {
                angular.forEach(contentObj.getTabs(), (tab, tabKey) => {
                    let objects = taskContext.read(tab.content);
                    objectsCounter += objects.data.objects.length;
                });
            } else if (contentObj.isShowCarousels()) {
                angular.forEach(contentObj.getCarousels(), (carousel, carouselKey) => {
                    let objects = taskContext.read(carousel.content);
                    objectsCounter += objects.data.objects.length;
                });
            } else if (typeof contentObj.data.objects !== "undefined") {
                objectsCounter += contentObj.data.objects.length;
            }
            return objectsCounter;
        };

        const addToBasket = (containerKey, i, key) => {
            let elem = document.querySelector('#copied-container-' + i);
            let elem1 = document.querySelector('#btn-basket-add-' + containerKey);
            let $a = $(elem1),
                $b = $(elem),
                bounds1 = $a.get(0).getBoundingClientRect(),
                bounds2 = $b.get(0).getBoundingClientRect();

            let $tmp = $a.clone();

            $tmp.css({
                width: bounds1.width,
                height: bounds1.height,
                opacity: 100,
                '-webkit-transform': 'translate(' + bounds1.left + 'px ,' + bounds1.top + 'px)',
                '-moz-transform': 'translate(' + bounds1.left + 'px ,' + bounds1.top + 'px)',
                '-ms-transform': 'translate(' + bounds1.left + 'px ,' + bounds1.top + 'px)',
                'transform': 'translate(' + bounds1.left + 'px ,' + bounds1.top + 'px)'
            });
            $tmp.addClass('animation-copy').appendTo(document.body);
            let animatable = window.getComputedStyle($tmp.get(0)).top;

            $tmp.css({
                width: bounds2.width,
                height: bounds2.height,
                opacity: 100,
                '-webkit-transform': 'translate(' + bounds2.left + 'px ,' + bounds2.top + 'px)',
                '-moz-transform': 'translate(' + bounds2.left + 'px ,' + bounds2.top + 'px)',
                '-ms-transform': 'translate(' + bounds2.left + 'px ,' + bounds2.top + 'px)',
                'transform': 'translate(' + bounds2.left + 'px ,' + bounds2.top + 'px)'
            });

            setTimeout(() => {
                CopyContainerHelperService.connect(true, key, false, containerKey);
                $tmp.remove();
            }, 500);
        };

        const getMediaURL = (mediaObject, thumbnail) => {
            let thumbnailSlug = '_thumb',
                thumbnailExtension = 'jpg';
            $scope.taskuuid = TaskSelectionService.getTaskUUID();

            if (!angular.isObject(mediaObject)) {
                return false;
            }

            thumbnail = angular.isDefined(thumbnail) ? thumbnail : false;
            let re = /(?:\.([^.]+))?$/,
                uploadName = mediaObject.getUploadName(),
                extension = thumbnail ? thumbnailExtension : re.exec(uploadName)[1],
                mimeType = mediaObject.getMimeType(),
                fileNameSlug = thumbnail ? thumbnailSlug : "",
                fileName = mediaObject.getUUID() + fileNameSlug + '.' + extension,
                url;

            if (mimeType == 'image/svg+xml') {
                fileName = mediaObject.getUUID() + fileNameSlug + '.svg';
            }

            url = isCMS ? "/media/" + $scope.taskuuid + "/" + fileName : "/media/" + fileName;

            return url;
        };

        const getMediaURLCopyContainer = (mediaObject, thumbnail) => {
            let thumbnailSlug = '_thumb',
                thumbnailExtension = 'jpg';
            $scope.taskuuid = TaskSelectionService.getTaskUUID();

            if (!angular.isObject(mediaObject)) {
                return false;
            }

            thumbnail = angular.isDefined(thumbnail) ? thumbnail : false;
            let re = /(?:\.([^.]+))?$/,
                uploadName = mediaObject.getUploadName(),
                extension = thumbnail ? thumbnailExtension : re.exec(uploadName)[1],
                mimeType = mediaObject.getMimeType(),
                fileNameSlug = thumbnail ? thumbnailSlug : '',
                fileName = mediaObject.getUUID() + fileNameSlug + '.' + extension,
                url;

            if (mimeType === 'image/svg+xml') {
                fileName = mediaObject.getUUID() + fileNameSlug + '.svg';
            }

            url = isCMS ? fileName : mediaObject.getUUID() + fileNameSlug;

            return url;
        };

        const getMediaUUIDCopyContainer = (mediaObject, thumbnail) => {
            if (!angular.isObject(mediaObject)) {
                return false;
            }

            return mediaObject.getUUID();
        };

        const getMediaNameCopyContainer = (mediaObject, thumbnail) => {
            if (!angular.isObject(mediaObject)) {
                return false;
            }

            return mediaObject.getUploadName();
        };

        const copyContainerContent = (jsonVar, containerKey, key) => {
            CopyContainerHelperService.copyContainer(jsonVar, containerKey, key, $scope.taskuuid, $routeParams.sheetUUID);
        };

        $scope.$on('addContainer', (event, data) => {
            console.log('ADD BASKET ===>', data);
            addToBasket(data.containerKey, data.length, data.key);
        });

        const decompression = (attachement) => {
            if (typeof attachement === "string" && attachement.indexOf(this.compressionKeyword) !== -1) {
                attachement = JSON.parse(pako.inflate(window.atob(attachement.replace(new RegExp(this.compressionKeyword, "g"), "")), this.compressionOptions));
            }
            return attachement;
        };

        function toDataURL(url, callback) {
            let xhr = new XMLHttpRequest();
            xhr.onload = function () {
                let reader = new FileReader();
                reader.onloadend = function () {
                    callback(reader.result);
                }
                reader.readAsDataURL(xhr.response);
            };
            xhr.open('GET', url);
            xhr.responseType = 'blob';
            xhr.send();
        }

        // All Signals Functions
        const signalsFunctions = {
            move_obj_up_down: (move, elementType, value) => {
                if (move === 'up') {
                    var moveStep = -1;
                } else if (move === 'down') {
                    var moveStep = +1;
                }
                switch (elementType) {
                    case "row":
                        var moveTo = (new_index) => {
                            $scope.scrollToElement = ".row-" + new_index;
                            var tmp = $scope.rows[value];
                            $scope.rows.splice(value, 1);
                            $scope.rows.splice(new_index, 0, tmp);
                            $signals.emit("rendering_rows", $scope.rows);
                        };

                        var new_index = value + moveStep;
                        if (move === 'up') {
                            if (value > 0) {
                                moveTo(new_index);
                            } else {
                                new_index = $scope.rows.length - 1;
                                moveTo(new_index);
                            }
                        } else if (move === 'down') {
                            if (value < $scope.rows.length - 1) {
                                moveTo(new_index);
                            } else {
                                moveTo(0);
                            }
                        }
                        break;
                    case "list":
                        if (typeof value.rowKey !== 'undefined' &&
                            typeof value.colKey !== 'undefined' &&
                            typeof value.containerKey !== 'undefined' &&
                            $scope.rows[value.rowKey].cols[value.colKey].list.length > 1) {

                            var moveTo = (new_index) => {
                                $scope.scrollToElement = ".container-" + value.rowKey + "-" + value.colKey + "-" + (new_index);
                                var tmp = $scope.rows[value.rowKey].cols[value.colKey].list[value.containerKey];
                                $scope.rows[value.rowKey].cols[value.colKey].list.splice(value.containerKey, 1);
                                $scope.rows[value.rowKey].cols[value.colKey].list.splice(new_index, 0, tmp);
                                $signals.emit("rendering_rows", $scope.rows);
                            };

                            var new_index = value.containerKey + moveStep;
                            if (move === 'up') {
                                if (value.containerKey > 0) {
                                    moveTo(new_index);
                                } else {
                                    new_index = $scope.rows[value.rowKey].cols[value.colKey].list.length - 1;
                                    moveTo(new_index);
                                }
                            } else if (move === 'down') {
                                if (value.containerKey < $scope.rows[value.rowKey].cols[value.colKey].list.length - 1) {
                                    moveTo(new_index);
                                } else {
                                    var new_index = 0;
                                    moveTo(0);
                                }
                            }
                        }
                        break;
                }
                $scope.layout.flagAsDirty();
            },
            delete_row: (rowKey) => {
                if ($scope.rows[rowKey].cols.length > 0 &&
                    ((typeof $scope.rows[rowKey].cols[0] !== 'undefined' && $scope.rows[rowKey].cols[0].list.length > 0) ||
                        (typeof $scope.rows[rowKey].cols[1] !== 'undefined' && $scope.rows[rowKey].cols[1].list.length > 0))) {
                    var objectsCounter = 0;

                    if (typeof $scope.rows[rowKey].cols[0] !== 'undefined') {
                        angular.forEach($scope.rows[rowKey].cols[0].list, (list, containerKey) => {
                            var contentObj = taskContext.read(list.content);
                            objectsCounter += helperCounterMethode(contentObj);
                        });
                    }
                    if (typeof $scope.rows[rowKey].cols[1] !== 'undefined') {
                        angular.forEach($scope.rows[rowKey].cols[1].list, (list, containerKey) => {
                            var contentObj = taskContext.read(list.content);
                            objectsCounter += helperCounterMethode(contentObj);
                        });
                    }
                    if (objectsCounter > 0) {
                        var message = $translate.instant('CMS.LAYOUT-MANAGER.WARNING-MESSAGES.DELETE', {
                            s1: objectsCounter
                        });
                        var deleteModalInstance = this.openDeleteModal(message, $uibModal, $signals);
                        deleteModalInstance.result.then(() => {
                        }, () => {
                            if (deleteModalInstance.delete) {
                                DeleteObjectHelperService.deleteRow($scope.layout, $scope.rows, rowKey);
                            }
                        });
                        return false;
                    }
                }
                DeleteObjectHelperService.deleteRow($scope.layout, $scope.rows, rowKey);
                $scope.layout.flagAsDirty();
            },
            delete_col: (rowKey, colKey) => {
                if ($scope.rows[rowKey].cols[colKey].list.length > 0) {
                    var objectsCounter = 0;

                    angular.forEach($scope.rows[rowKey].cols[colKey].list, (list, containerKey) => {
                        var contentObj = taskContext.read(list.content);
                        objectsCounter += helperCounterMethode(contentObj);
                    });

                    if (objectsCounter > 0) {
                        var message = $translate.instant('CMS.LAYOUT-MANAGER.WARNING-MESSAGES.DELETE', {
                            s1: objectsCounter
                        });
                        var deleteModalInstance = this.openDeleteModal(message, $uibModal, $signals);
                        deleteModalInstance.result.then(() => {
                        }, () => {
                            if (deleteModalInstance.delete) {
                                DeleteObjectHelperService.deleteCol($scope.layout, $scope.rows, rowKey, colKey);
                            }
                        });
                        return false;
                    }
                }
                DeleteObjectHelperService.deleteCol($scope.layout, $scope.rows, rowKey, colKey);
            },
            delete_list: (rowKey, colKey, containerKey) => {
                var list = $scope.rows[rowKey].cols[colKey].list[containerKey];
                var _containerEntry = taskContext.read(list.content);
                var objectsCounter = 0;

                if (objectsCounter > 0) {
                    var message = $translate.instant('CMS.LAYOUT-MANAGER.WARNING-MESSAGES.DELETE', {
                        s1: objectsCounter
                    });
                    var deleteModalInstance = this.openDeleteModal(message, $uibModal, $signals);
                    deleteModalInstance.result.then(() => {
                    }, () => {
                        if (deleteModalInstance.delete) {
                            DeleteObjectHelperService.deleteContainer($scope.layout, $scope.rows, rowKey, colKey, containerKey, _containerEntry);
                        }
                    });
                    return false;
                }
                DeleteObjectHelperService.deleteContainer($scope.layout, $scope.rows, rowKey, colKey, containerKey, _containerEntry);
            },
            copy_container: (rowKey, colKey, containerKey) => {
                let jsonVar = [];
                let list = $scope.rows[rowKey].cols[colKey].list[containerKey];
                let _containerEntry = taskContext.read(list.content);
                let containerUUID = $scope.rows[rowKey].cols[colKey].list[containerKey].content;
                let containerEntry = taskContext.read(containerUUID);

                let labelData = {
                    'label': 'undefined',
                };

                if (containerEntry.isShowTabs()) {
                    $scope.tabs = {};
                    let tab = containerEntry.getTabs();

                    for (let i = 0, len = tab.length; i < len; i++) {
                        let tabEntry = taskContext.read(tab[i].content);

                        $scope.tabs[tab[i].content] = tabEntry.getPreferences();
                        $scope.tabObjectsData = [];

                        let tabObj = tabEntry.getObjects();
                        for (let j = 0, objLen = tabObj.length; j < objLen; j++) {
                            taskContext.read(tabObj[j]).save();
                            let mediaObject = taskContext.read(tabObj[j]).getObjectType() === 'image' ||
                            taskContext.read(tabObj[j]).getObjectType() === 'audio' ||
                            taskContext.read(tabObj[j]).getObjectType() === 'universalcanvas' ||
                            taskContext.read(tabObj[j]).getObjectType() === 'iframe' ||
                            taskContext.read(tabObj[j]).getObjectType() === 'video' ? taskContext.read(tabObj[j]).getContentReference(false) : null;
                            $scope.instancesPalette = [];
                            $scope.mediaObjetName = [];
                            $scope.mediaObjetPath = [];
                            $scope.mediaObjetUUID = [];

                            if (taskContext.read(tabObj[j]).getObjectType() === 'audio' && taskContext.read(tabObj[j]).getAttachement()) {
                                $scope.audioBgMediaObject = taskContext.read(taskContext.read(tabObj[j]).getAttachement());
                                $scope.mediaObjetPath.push(getMediaURLCopyContainer($scope.audioBgMediaObject));
                                $scope.mediaObjetUUID.push(getMediaUUIDCopyContainer($scope.audioBgMediaObject));
                                $scope.mediaObjetName.push(getMediaNameCopyContainer($scope.audioBgMediaObject));
                            }

                            if (mediaObject !== null) {
                                $scope.mediaObject = mediaObject;
                                $scope.mediaObjetUUID.push(getMediaUUIDCopyContainer($scope.mediaObject));
                                $scope.mediaObjetPath.push(getMediaURLCopyContainer($scope.mediaObject));
                                $scope.mediaObjetName.push(getMediaNameCopyContainer($scope.mediaObject));
                            } else {
                                $scope.mediaObjetPath = false;
                                $scope.mediaObjetUUID = containerEntry.getTabs()[i].content;
                            }
                            $scope.tabObjectsData.push(taskContext.read(tabObj[j]).data);
                        }
                        jsonVar = jsonVar.concat('tab_copy::' + angular.toJson(containerEntry.getTabs()[i]) + '::' + angular.toJson(tabEntry.getPreferences()) + '::' + angular.toJson($scope.tabObjectsData) + '::' + angular.toJson($scope.mediaObjetPath) + '::' + angular.toJson($scope.mediaObjetUUID) + '::' + angular.toJson(labelData) + '::' + angular.toJson($scope.mediaObjetName) + '::' + angular.toJson($scope.instancesPalette));

                        if (i === tab.length - 1) {
                            copyContainerContent(jsonVar, containerKey, 'tab_copy');
                        }
                    }
                }

                if (containerEntry.isShowCarousels()) {
                    let carousel = containerEntry.getCarousels();
                    for (let k = 0, carouselLen = carousel.length; k < carouselLen; k++) {
                        let carouselEntry = taskContext.read(carousel[k].content);
                        let carouselObj = carouselEntry.getObjects();
                        $scope.carouselObjectsData = [];
                        $scope.mediaObjetPath = [];
                        $scope.mediaObjetUUID = [];
                        $scope.mediaObjetName = [];
                        $scope.instancesPalette = [];

                        let labelData = {
                            'label': 'undefined',
                        };
                        for (let l = 0, carouselObjLen = carouselObj.length; l < carouselObjLen; l++) {
                            taskContext.read(carouselObj[l]).save();
                            let mediaObject = taskContext.read(carouselObj[l]).getObjectType() === 'image' ||
                            taskContext.read(carouselObj[l]).getObjectType() === 'audio' ||
                            taskContext.read(carouselObj[l]).getObjectType() === 'iframe' ||
                            taskContext.read(carouselObj[l]).getObjectType() === 'universalcanvas' ||
                            taskContext.read(carouselObj[l]).getObjectType() === 'video' ? taskContext.read(carouselObj[l]).getContentReference(false) : null;

                            if (taskContext.read(carouselObj[l]).getObjectType() === 'audio' && taskContext.read(carouselObj[l]).getAttachement()) {
                                $scope.audioBgMediaObject = taskContext.read(taskContext.read(carouselObj[l]).getAttachement());
                                $scope.mediaObjetPath.push(getMediaURLCopyContainer($scope.audioBgMediaObject));
                                $scope.mediaObjetUUID.push(getMediaUUIDCopyContainer($scope.audioBgMediaObject));
                                $scope.mediaObjetName.push(getMediaNameCopyContainer($scope.audioBgMediaObject));
                            }

                            if (mediaObject !== null) {
                                $scope.mediaObject = mediaObject;
                                $scope.mediaObjetPath.push(getMediaURLCopyContainer($scope.mediaObject))
                                $scope.mediaObjetUUID.push(getMediaUUIDCopyContainer($scope.mediaObject));
                                $scope.mediaObjetName.push(getMediaNameCopyContainer($scope.mediaObject));
                            } else if ($scope.mediaObjetPath.length === 0) {
                                $scope.mediaObjetPath = false;
                            }
                            $scope.carouselObjectsData.push(taskContext.read(carouselObj[l]).data);
                        }
                        jsonVar = jsonVar.concat('carousel_copy::' + angular.toJson(containerEntry.getCarousels()[k]) + '::' + angular.toJson(carouselEntry.getPreferences()) + '::' + angular.toJson($scope.carouselObjectsData) + '::' + angular.toJson($scope.mediaObjetPath) + '::' + angular.toJson($scope.mediaObjetUUID) + '::' + angular.toJson(labelData) + '::' + angular.toJson($scope.mediaObjetName) + '::' + angular.toJson($scope.instancesPalette));
                        if (k === carousel.length - 1) {
                            copyContainerContent(jsonVar, containerKey, 'carousel_copy');
                        }
                    }
                }

                if (containerEntry.isShowIaaContainer()) {
                    angular.forEach(containerEntry.getIaaContainer(), (iaaContainer, iaaContainerKey) => {
                        let iaaContainerEntry = taskContext.read(iaaContainer.content);
                        angular.forEach(iaaContainerEntry.getObjects(), (iaaContainerObj, iaaContainerObjkey) => {
                            taskContext.read(iaaContainerObj).save();
                            let mediaObject = taskContext.read(iaaContainerObj).getObjectType() === 'image' ||
                            taskContext.read(iaaContainerObj).getObjectType() === 'audio' ||
                            taskContext.read(iaaContainerObj).getObjectType() === 'universalcanvas' ||
                            taskContext.read(iaaContainerObj).getObjectType() === 'iframe' ||
                            taskContext.read(iaaContainerObj).getObjectType() === 'video' ? taskContext.read(iaaContainerObj).getContentReference(false) : null;

                            $scope.mediaObjetPath = [];
                            $scope.mediaObjetUUID = [];
                            $scope.mediaObjetName = [];
                            $scope.instancesPalette = [];

                            let labelData = {
                                'label': 'undefined',
                            };

                            if (taskContext.read(iaaContainerObj).getObjectType() === 'audio' && taskContext.read(iaaContainerObj).getAttachement()) {
                                $scope.audioBgMediaObject = taskContext.read(taskContext.read(iaaContainerObj).getAttachement());
                                $scope.mediaObjetPath.push(getMediaURLCopyContainer($scope.audioBgMediaObject));
                                $scope.mediaObjetUUID.push(getMediaUUIDCopyContainer($scope.audioBgMediaObject));
                                $scope.mediaObjetName.push(getMediaNameCopyContainer($scope.audioBgMediaObject));
                            }

                            if (mediaObject !== null) {
                                $scope.mediaObject = mediaObject;
                                $scope.mediaObjetPath.push(getMediaURLCopyContainer($scope.mediaObject))
                                $scope.mediaObjetUUID.push(getMediaUUIDCopyContainer($scope.mediaObject));
                                $scope.mediaObjetName.push(getMediaNameCopyContainer($scope.mediaObject));
                            } else {
                                $scope.mediaObjetPath = false;
                            }
                            jsonVar = jsonVar.concat('iaaContainer_copy::' + angular.toJson(containerEntry.getIaaContainer()[iaaContainerKey]) + '::' + angular.toJson(iaaContainerEntry.getPreferences()) + '::' + angular.toJson(taskContext.read(iaaContainerObj).data) + '::' + angular.toJson($scope.mediaObjetPath) + '::' + angular.toJson($scope.mediaObjetUUID) + '::' + angular.toJson(labelData) + '::' + angular.toJson($scope.mediaObjetName) + '::' + angular.toJson($scope.instancesPalette));
                        });
                        if (iaaContainerKey === containerEntry.getIaaContainer().length - 1) {
                            copyContainerContent(jsonVar, containerKey, 'iaaContainer_copy');
                        }
                    });
                }

                angular.forEach(_containerEntry.getObjects(), (objectUUID, objKey) => {
                    taskContext.read(objectUUID).save();
                    let mediaObject = taskContext.read(objectUUID).getObjectType() === 'image' ||
                        taskContext.read(objectUUID).getObjectType() === 'audio' ||
                        taskContext.read(objectUUID).getObjectType() === 'universalcanvas' ||
                        taskContext.read(objectUUID).getObjectType() === 'iframe' ||
                        taskContext.read(objectUUID).getObjectType() === 'video' ? taskContext.read(objectUUID).getContentReference(false) : null;

                    let result = {
                        defaultImage: [],
                        images: []
                    };

                    let labelData = {
                        'label': 'undefined',
                    };
                    $scope.taskuuid = TaskSelectionService.getTaskUUID();
                    $scope.mediaObjetPath = [];
                    $scope.mediaObjetUUID = [];
                    $scope.mediaObjetName = [];
                    $scope.paletts = [];
                    $scope.palettsMain = [];
                    $scope.instancesPalette = [];

                    if (taskContext.read(objectUUID).getObjectType() === 'universalcanvas') {
                        let instances = taskContext.findInstancesByType('universalCanvasPalette');
                        let instancesPalette = {};
                        let universalCanvasPaletteObjects = taskContext.findInstancesByType('universalCanvasPalette');

                        for (let id in universalCanvasPaletteObjects) {
                            if (universalCanvasPaletteObjects.hasOwnProperty(id)) {
                                let universalCanvasPaletteObject = universalCanvasPaletteObjects[id];
                                instancesPalette[id] = {
                                    uuid: id,
                                    type: universalCanvasPaletteObject.getType(),
                                    name: universalCanvasPaletteObject.getName(),
                                    items: universalCanvasPaletteObject.getItems(),
                                }
                            }
                        }
                        $scope.instancesPalette = instancesPalette;

                        let imagesPalettes = instances;
                        for (let key in imagesPalettes) {
                            if (imagesPalettes.hasOwnProperty(key) && imagesPalettes[key].getItems()) {
                                result.images = result.images.concat(imagesPalettes[key].getItems().map((item) => {
                                    return {
                                        'uuid': item.uuid,
                                        'type': 'image',
                                        'xlink': taskContext.read(item.uuid).getExtendedMediaURLCopiedContainer($scope.taskuuid)
                                    };
                                }));
                                result.images = _.sortBy(result.images, 'position');
                            }
                        }
                    }
                    for (let idx in result.images) {
                        $scope.mediaObjetPath.push(result.images[idx].xlink)
                    }

                    if (taskContext.read(objectUUID).getObjectType() === 'audio' && taskContext.read(objectUUID).getAttachement()) {
                        $scope.audioBgMediaObject = taskContext.read(taskContext.read(objectUUID).getAttachement());
                        $scope.mediaObjetPath.push(getMediaURLCopyContainer($scope.audioBgMediaObject));
                        $scope.mediaObjetUUID.push(getMediaUUIDCopyContainer($scope.audioBgMediaObject));
                        $scope.mediaObjetName.push(getMediaNameCopyContainer($scope.audioBgMediaObject));
                    }

                    if (mediaObject !== null) {
                        $scope.mediaObject = mediaObject;
                        $scope.mediaObjetPath.push(getMediaURLCopyContainer($scope.mediaObject));
                        $scope.mediaObjetUUID.push(getMediaUUIDCopyContainer($scope.mediaObject));
                        $scope.mediaObjetName.push(getMediaNameCopyContainer($scope.mediaObject));
                    } else if ($scope.mediaObjetPath.length === 0) {
                        $scope.mediaObjetPath = false;
                    }

                    jsonVar = jsonVar.concat('container_copy1::' + angular.toJson(taskContext.read(objectUUID).data) + '::' + angular.toJson(taskContext.read(objectUUID)) + '::' + null + '::' + angular.toJson($scope.mediaObjetPath) + '::' + angular.toJson($scope.mediaObjetUUID) + '::' + angular.toJson(labelData) + '::' + angular.toJson($scope.mediaObjetName) + '::' + angular.toJson($scope.instancesPalette));
                    if (objKey === _containerEntry.getObjects().length - 1) {
                        copyContainerContent(jsonVar, containerKey, 'container_copy1');
                    }
                });
            },
            scroll_to_element: (element) => {
                if (typeof element !== 'undefined') {
                    $scope.scrollHeight = $(element).offset().top - 100;
                    $('html, body').animate({
                        scrollTop: $scope.scrollHeight
                    }, 1000);
                }
            },
            rendering_rows: (rows) => {
                this.renderingRows(rows, $scope, $timeout, $translate, taskContext, $uibModal, SheetLoadedService);
            },
            sortable_stop: (rows) => {
                $scope.layout.flagAsDirty();
                this.renderingRows(rows, $scope, $timeout, $translate, taskContext, $uibModal, SheetLoadedService);
            },
            update_question_part_list: () => {
                $scope.questionParts = this.getQuestionPartList($scope.sheet, taskContext, $routeParams, $translate);
                this.renderingRows($scope.layout.getRows(), $scope, $timeout, $translate, taskContext, $uibModal, SheetLoadedService);
            }
        };

        // Init all Signals
        angular.forEach(signalsFunctions, (value, key) => {
            $signals.remove(key);
            $signals.on(key, value);
        });

        $scope.move_obj_up_down = signalsFunctions.move_obj_up_down;
        $scope.delete_row = signalsFunctions.delete_row;
        $scope.delete_col = signalsFunctions.delete_col;
        $scope.delete_list = signalsFunctions.delete_list;
        $scope.copy_container = signalsFunctions.copy_container;
        $scope.scroll_to_element = signalsFunctions.scroll_to_element;
    }

    getQuestionPartList(sheet, taskContext, $routeParams, $translate) {
        let questionParts = taskContext.read($routeParams.sheetUUID).getQuestionParts();
        let _result = [];

        _result.splice(0, 0, {
            index: null,
            label: '----'
        });
        angular.forEach(questionParts, (value, key) => {
            _result.splice(questionParts.length, 0, {
                index: value.getUUID(),
                label: value.getTitle() ? value.getTitle() : sheet.getTitle() ? (sheet.getTitle() + value.getShortTitle()) : ($translate.instant('PREFIX.QUESTION-PART') + " " + (sheet.getShortTitle() + value.getShortTitle()))
            });
        });

        return _result;
    }
}

export { GridLayoutDirective };

export default function registerGridLayoutDirective(assessmentFrontendDirectives) {
    assessmentFrontendDirectives.directive('asfGridLayout', ['$routeParams', '$config', 'TaskDataService', '$signals', '$timeout', '$translate', 'CMSSortableService', '$uibModal', 'DeleteObjectHelperService', 'SheetLoadedService', 'CopyContainerHelperService', 'CryptoHelperService', 'TaskSelectionService',
        function ($routeParams, $config, TaskDataService, $signals, $timeout, $translate, CMSSortableService, $uibModal, DeleteObjectHelperService, SheetLoadedService, CopyContainerHelperService, CryptoHelperService, TaskSelectionService) {
            return {
                restrict: "E",
                replace: true,
                scope: {
                    layout: '=',
                    sheet: '=',
                    filterBy: '='
                },
                templateUrl: function () {
                    if (!$config.isPreviewMode() && isCMS && !$config.isPDFMode()) {
                        return '/views/ib/components/GridLayoutDirectiveCMS.html';
                    }
                    return '/views/ib/components/GridLayoutDirective.html';
                },
                controller: GridLayoutDirective,
                /*controllerAs: 'vm',
                bindToController: false*/
            };
        }
    ]);
}